<template>
  <div style="width: 100%; height: 100%; position: absolute; overflow: hidden">
    <div class="page-header">
      <img class="header-icon" src="~@/assets/images/header-icon.png" />
      <template v-if="isMenu">
        <img
          v-if="!isShowMenu"
          class="header-menu"
          @touchstart="menuTouch"
          src="~@/assets/images/header-menu-icon.png"
        />
        <img
          v-else
          class="header-menu-close"
          @touchstart="menuTouch"
          src="~@/assets/images/header-close.png"
        />
      </template>
    </div>
    <div
      class="menu-container"
      :class="{ trans: isShowMenu }"
      ref="menuContainer"
    >
      <img class="menu-bg" src="~@/assets/images/header-menu-bg.png" />
      <ul class="menu-list">
        <li @touchstart="itemTouch(0)">
          <img src="~@/assets/images/header-menu-1.png" />
        </li>
        <li @touchstart="itemTouch(1)">
          <img src="~@/assets/images/header-menu-2.png" />
        </li>
        <li @touchstart="itemTouch(2)">
          <img src="~@/assets/images/header-menu-3.png" />
        </li>
        <li @touchstart="itemTouch(3)">
          <img src="~@/assets/images/header-menu-4.png" />
        </li>
        <li @touchstart="itemTouch(4)">
          <img src="~@/assets/images/header-menu-5.png" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

defineProps({
  isMenu: {
    type: Boolean,
    default: true,
  },
});

const isShowMenu = ref(false);

const emits = defineEmits(["list-change"]);
const menuContainer = ref();

const menuTouch = () => {
  isShowMenu.value = !isShowMenu.value;
};
const itemTouch = (e) => {
  console.log(e);
  isShowMenu.value = false;
  emits("list-change", e);
};
</script>

<style lang="scss" scoped>
.page-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  // height: 6.1111rem;
  height: 6.6rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4.2593rem;
  z-index: 999;

  .header-icon {
    width: 26.3889rem;
    height: 6.333rem;
    position: relative;
    z-index: 999;
  }
  .header-menu {
    width: 6.5741rem;
    height: 5.3704rem;
  }
  .header-menu-close {
    width: 6.2037rem;
    height: 5.1852rem;
    animation: menu-close-keyframe 0.3s;

    @keyframes menu-close-keyframe {
      0% {
        transform: rotate(-90deg);
        opacity: 0.5;
      }
      50% {
        opacity: 0.8;
      }
      100% {
        transform: rotate(0deg);
        opacity: 1;
      }
    }
  }
}
.menu-container {
  position: absolute;
  top: 0;
  left: 0;
  font-size: 0;
  z-index: 0;
  height: 100%;
  width: 100%;

  transform: translateY(36vh);
  opacity: 0.5;
  visibility: hidden;

  &.trans {
    z-index: 998;
    // 只有出现需要动画
    transition: all 0.36s;
    transform: translateY(0);
    opacity: 1;
    visibility: visible;
  }

  // animation: menu-keyframe 0.36s;

  // @keyframes menu-keyframe {
  //   0% {
  //     transform: translateY(36vh);
  //     opacity: 0.5;
  //   }
  //   50% {
  //     opacity: 0.8;
  //   }
  //   100% {
  //     transform: translateY(0);
  //     opacity: 1;
  //   }
  // }

  .menu-bg {
    width: 100%;
    height: 100%;
  }
  .menu-list {
    position: absolute;
    top: 17.5926rem;
    left: 0;
    right: 0;

    padding: 0 4.2593rem;
    // box-sizing: border-box;
    // width: 100%;

    li {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 17.963rem;
      border-top: 0.0926rem solid #d8e9f389;
      &:last-child {
        border-bottom: 0.0926rem solid #d8e9f389;
      }

      img {
        width: 17.5926rem;
        height: 4.1667rem;
      }
    }
  }
}
.page-bottom {
  position: absolute;
  text-align: center;
  // bottom: 2.7037rem;
  bottom: 1.7037rem;
  left: 0;
  right: 0;
  z-index: 2;
  transform-style: preserve-3d;

    transform: translateZ(0);
  img {
    width: 4.0741rem;
    height: 6.4815rem;

    transform: translateZ(0);
    
    animation: bottom-keyframes 3.6s infinite ease-out;
    @keyframes bottom-keyframes {
      0% {
        transform: translateY(0) translateZ(0);
        opacity: 1;
      }
      50% {
        transform: translateY(-3rem) translateZ(0);
        opacity: 1;
      }
      100% {
        transform: translateY(-3rem) translateZ(0);
        opacity: 0;
      }
    }
  }
}
</style>